import { Typography, styled } from '@mui/material';

import type { Theme } from '@mui/material';

export const Title = styled(Typography)(({ theme }: { theme: Theme }) => ({
	wordWrap: 'break-word',
	color: theme.palette.tsGoColor.black,
	margin: 0,
	fontWeight: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
		? theme.typography.tsFontWeight.bolder
		: theme.typography.tsFontWeight.default,
	lineHeight: theme.typography.pxToRem(30),
	boxSizing: 'border-box',
	fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.big),
	padding: `${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnit}`,
}));

export const HbscTitle = styled(Typography)(({ theme }: { theme: Theme }) => ({
	wordWrap: 'break-word',
	color: theme.palette.tsGoColor.black,
	margin: 0,
	fontWeight: theme.typography.tsFontWeight.default,
	lineHeight: theme.typography.pxToRem(30),
	boxSizing: 'border-box',
	fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.medium),
	padding: `${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnit}`,
}));
